import { render, staticRenderFns } from "./ContentItemsEdit.vue?vue&type=template&id=6dc14374&"
import script from "./ContentItemsEdit.vue?vue&type=script&lang=js&"
export * from "./ContentItemsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports